/**
 * Created by JasonChou on 16/12/12.
 */
const state = {
  appInfo: null,
  pages: [],
  layoutSwitch: false, // 布局状态切换
  templateControls: [],
  editType: 'page', // header,footer,page
  privatizationDeployStatus: false, // 私有化部署状态
  serverTime: 0,
  // 流程图相关
  initialFlowMap: {}, // 初始化状态记录
  flows: [], // 记录流程列表
  currentFlow: {}, // 当前流程
  currentNodes: [], // 当前选中节点列表,
  flowOpenLists: [], // 打开的目录列表
  editorFlowTabStatus: false
};

const mutations = {
  INIT_APP_INFO (state, appInfo, currentPage, pageMaps, serverTime) {
    state.appInfo = appInfo;
    state.pageMaps = pageMaps
    state.serverTime = serverTime
  },

  SET_APP_INFO (state, appinfo) {
    state.appInfo = appinfo;
  },

  SET_APP_LAYOUT_SWITCH (state, isSwitch) {
    state.layoutSwitch = isSwitch;
  },

  SET_APP_FLOWS (state, flows) {

    state.flows = flows;
    for (const flow of flows) {
      state.initialFlowMap[flow._id] = JSON.stringify(flow);
    }
  },

  /** 获取修改单个流程 */
  SET_APP_FLOW (state, flow) {
    let index = -1
    for (let [i, item] of state.flows.entries()) {
      if (item._id === flow._id) {
        index = i
        break
      }
    }
    index > -1 ? state.flows.splice(index, 1, flow) : state.flows.push(flow)
    state.initialFlowMap[flow._id] = JSON.stringify(flow);
  },


  UPDATE_APP_FLOWS (state, flows) {
    for (const flow of flows) {
      state.initialFlowMap[flow._id] = JSON.stringify(flow);
    }
  },

  SET_APP_FLOW_NODES (state, node, type) {
    if (type === 'append') {
      if (state.currentNodes.indexOf(node) === -1) {
        state.currentNodes.push(node);
      }
    } else if (type === 'select') {
      state.currentNodes = [node];
    } else if (type === 'replace') {
      state.currentNodes = node
    }
  },

  SET_FLOW_OPENLISTS (state, lists) {
    state.flowOpenLists = lists;
  },

  CHOOSE_FLOW (state, flow = {}) {
    state.currentFlow = flow;
    const { options = [] } = flow;
    if (options.length) {
      const start = (options.find(item => state.currentNodes.includes(item.id)) || options.find(item => item.start == true)) || options[0];
      state.currentNodes = [start.id];
    }
  },

  ADD_FLOW (state, flow) {
    if (Array.isArray(flow)) {
      flow.map(item => state.flows.push(item))
    } else {
      state.flows.push(flow);
    }
  },
  UPDATE_FLOW (state, flow) {
    if (Array.isArray(flow)) {
      flow.map(item => {
        let flIdx = state.flows.findIndex(items => items.flow_id === item.flow_id)
        if (flIdx !== -1) {
          state.flows.splice(flIdx, 1, item)
        } else {
          state.flows.push(item)
        }
        if (item._id === state.currentFlow._id) {
          state.currentFlow = item
        }
      })
    } else {
      state.flows = state.flows.map(item => {
        if (item._id === flow._id) {
          item = flow;
        }
        return item;
      });
    }
  },
  DELETE_FLOW (state, id) {
    const index = state.flows.findIndex(item => item._id === id);
    state.flows.splice(index, 1);

    state.currentFlow = {};
    state.currentNodes = [];
  },

  CHANGE_FLOW (state, key, value) {
    state.flows = state.flows.map(item => {
      if (item._id === state.currentFlow._id) {
        item[key] = value;
        state.currentFlow = item;
      }
      return item;
    });
  },

  ADD_PAGE (state, page) {
    state.pages.push(page);
  },

  REFRESH_PAGES_CACHE (state, pages) {
    state.pages = pages;
  },

  // if page self not exist, then store controls in templateControls
  // otherwise, complete page with param controls
  UPDATE_PAGE_CONTROLS (state, pageId, controls) {
    const index = state.pages.findIndex(page => page.page_id === pageId);
    console.log('state.pages', state.pages);
    console.log('UPDATE_PAGE_CONTROLS', index);
    if (index === -1) {
      state.templateControls.push({
        pageId,
        controls,
      });
    } else {
      state.pages[index].controls = controls;
    }
  },

  READ_CONTROLS_FROM_TEMPLATE (state) {
    state.templateControls.map((controlIt) => {
      const index = state.pages.findIndex(page => page.page_id === controlIt.pageId);
      if (index !== -1) {
        state.pages[index].controls = controlIt.controls;
      } else console.warn('in mutation READ_CONTROLS_FROM_TEMPLATE, cannot find pageId: ', controlIt);
    });
    state.templateControls = [];
  },

  CLEAN_CONTROLS_TEMPLATE (state) {
    state.templateControls = [];
  },

  UPDATE_PAGES_CACHE (state, pageId, page) {
    const index = state.pages.findIndex(page => page.page_id === pageId);
    if (index === -1) {
      state.pages.push(page);
    } else {
      if (page) {
        state.pages[index] = page;
      } else {
        state.pages.splice(index, 1);
      }
    }
  },

  CHANGE_EDIT_TYPE (state, editType) {
    state.editType = editType;
  },

  CHANGE_DEPLOY_STATUS (state, status) {
    state.privatizationDeployStatus = status;
  },

  CHANGE_EDITOR_TAB_FLOW_TYPE (state, editorFlowTabStatus) {
    state.editorFlowTabStatus = editorFlowTabStatus;
  }
};

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/stores/app.js